/*
  Cart-context quick-add drawer behavior.
  Extracted 2026-09-01 from the inline <script> in
  snippets/cart-upsell-quick-add-drawer.liquid (verbatim, zero Liquid).

  Loaded `defer` from that snippet. Self-guarded via
  window.__neswCartUpsellDrawerMounted so a double-render of the
  snippet (cart-drawer.liquid + cart-section.liquid both include it)
  stays safe — the second load is a no-op.
*/
(function () {
  if (window.__neswCartUpsellDrawerMounted) return;
  window.__neswCartUpsellDrawerMounted = true;

  function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }

  function inCartContext(el) {
    return !!(el && el.closest && (
      el.closest('.cart-drawer-upsell-wrap') ||
      el.closest('.nesw-upsell-cards') ||
      el.closest('.cart-page-upsell-wrap')
    ));
  }

  var drawer = document.getElementById('cuq-drawer'); /* null since 2026-09-25: the sheet markup is gone */
  var imgEl   = document.getElementById('cuq-product-image');
  var titleEl = document.getElementById('cuq-product-title');
  var colorEl = document.getElementById('cuq-product-variant');
  var priceEl = document.getElementById('cuq-product-price');
  var sizesEl = document.getElementById('cuq-sizes-list');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    /* Do not hand scrolling back if the cart drawer is still open behind this
       sheet: it set the lock and expects to keep it. Now that adding from Pair
       It With leaves the drawer open, clearing it here let the page scroll
       underneath an open cart. */
    var __cd = document.getElementById('cart-drawer');
    document.body.style.overflow = (__cd && __cd.classList.contains('open')) ? 'hidden' : '';
  }

  /* 2026-09-25: the sheet this file used to open (#cuq-drawer) is gone. The quick-add modal
     (assets/nesw-qad-drawer.js) is the ONE sheet on every card, cart contexts included; the
     card's ADD carries data-qad-open. What stays here: the swatch swap on cart upsell cards
     and the tap guard (the hover strip and its pill handler went with round three). */
  /* ──────── Swatch click handler (cart upsell) ────────
     PDP related-products has its own swatch handler (scoped to that
     section's container element), so it never bound in cart contexts.
     Without this, tapping a swatch on a cart upsell card did
     literally nothing. Mirrors the PDP handler's behavior: swap the
     card's primary image, swap the visible color name, mark the new
     swatch active. The drawer then reads the new active swatch when
     it opens (the quick-add modal reads the active swatch), so picking a color → tapping
     bag picks the right variant. */
  document.addEventListener('click', function (e) {
    var swatch = e.target && e.target.closest && e.target.closest('.related-color-swatch');
    if (!swatch) return;
    if (!inCartContext(swatch)) return;

    e.preventDefault();
    e.stopPropagation();

    var card = swatch.closest('.product-recommendations-card');
    if (!card) return;
    var color = (swatch.dataset.color || '').trim();
    var image = swatch.dataset.image || '';
    /* The quick-add modal reads the wrapper's pick first (2026-09-25). */
    var qw = card.querySelector('.quick-add-wrapper');
    if (qw) { qw.dataset.selectedColor = color; if (image) qw.dataset.selectedColorImage = image; else delete qw.dataset.selectedColorImage; }

    /* Active state — clear siblings, mark this one. */
    card.querySelectorAll('.related-color-swatch').forEach(function (s) {
      s.classList.remove('active');
    });
    swatch.classList.add('active');

    /* Image swap. Browsers preload the swatch's `data-image` lazily;
       a quick opacity dip masks the small load delay if it's first
       paint, instantaneous if cached. */
    var img = card.querySelector('.related-product-img-primary');
    if (img && image) {
      img.style.transition = 'opacity 0.12s ease';
      img.style.opacity = '0.65';
      var newImg = new Image();
      newImg.onload = function () {
        img.src = image;
        img.style.opacity = '1';
      };
      newImg.onerror = function () { img.style.opacity = '1'; };
      newImg.src = image;
    }

    /* Color name in the "Black · 3 Colors" line. */
    var colorNameEl = card.querySelector('.related-current-color');
    if (colorNameEl && color) colorNameEl.textContent = color;
  }, true);

  /* ──────── Tap-guard for cart upsell cards ────────
     Mirrors the home-row guard (`sections/nesw-collection-row.liquid`)
     so the same vertical-scroll → accidental-card-tap problem doesn't
     happen on cart contexts either. If the finger moves more than the
     threshold during the touch — OR if the page/drawer/track scrolls
     — the subsequent click on the card link is cancelled before the
     `<a>` follows the href.

     Stricter on the cart page (8px threshold) than the drawer (12px):
     the cart page is where the customer is actively scrolling toward
     CHECKOUT and an accidental nav to a PDP costs the most. */
  var __tgX = null, __tgY = null, __tgMax = 0, __tgStart = null, __tgScrolled = false;
  var __THRESH_DRAWER = 12;
  var __THRESH_PAGE = 8;

  function __tgNoteScroll() {
    if (__tgStart !== null) __tgScrolled = true;
  }
  window.addEventListener('scroll', __tgNoteScroll, { passive: true });
  /* Bind scroll on the upsell row + cart-drawer content scrollers so
     non-window scroll containers also flip the flag. */
  function __tgBindScrollables() {
    document.querySelectorAll(
      '.cart-page-upsell-wrap .related-products-scroll-container,' +
      '.cart-drawer-upsell-wrap .related-products-scroll-container,' +
      '.cart-drawer-content'
    ).forEach(function (el) {
      if (el.__tgBound) return;
      el.__tgBound = true;
      el.addEventListener('scroll', __tgNoteScroll, { passive: true });
    });
  }
  __tgBindScrollables();
  window.addEventListener('load', __tgBindScrollables);
  /* Drawer is rendered dynamically; rebind when it opens. */
  document.addEventListener('cart:change', __tgBindScrollables);

  function inUpsellContext(el) {
    return !!(el && el.closest && (
      el.closest('.cart-page-upsell-wrap') ||
      el.closest('.cart-drawer-upsell-wrap')
    ));
  }

  document.addEventListener('touchstart', function (e) {
    var card = e.target && e.target.closest && e.target.closest('.product-recommendations-card');
    if (!card) return;
    if (!inUpsellContext(card)) return;
    if (!e.touches || !e.touches[0]) return;
    __tgX = e.touches[0].clientX;
    __tgY = e.touches[0].clientY;
    __tgMax = 0;
    __tgStart = Date.now();
    __tgScrolled = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (__tgStart === null || !e.touches || !e.touches[0]) return;
    var dx = e.touches[0].clientX - __tgX;
    var dy = e.touches[0].clientY - __tgY;
    var d = Math.sqrt(dx * dx + dy * dy);
    if (d > __tgMax) __tgMax = d;
  }, { passive: true });

  /* Capture phase so we beat the `<a>` navigation. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var card = e.target.closest('.product-recommendations-card');
    if (!card || !inUpsellContext(card)) {
      __tgStart = null;
      __tgScrolled = false;
      __tgMax = 0;
      return;
    }
    /* Allow clicks on interactive descendants (quick-add bag icon,
       swatches, size selector buttons). The guard ONLY cancels bare
       navigation on the card's <a> wrapper. */
    if (e.target.closest('.related-quick-add-btn, .related-color-swatch, .related-size-btn, .nesw-bookmark, button')) {
      __tgStart = null;
      __tgScrolled = false;
      __tgMax = 0;
      return;
    }
    /* Pick the per-surface threshold. Cart page = stricter. */
    var threshold = card.closest('.cart-page-upsell-wrap') ? __THRESH_PAGE : __THRESH_DRAWER;
    if (__tgStart !== null && (__tgMax > threshold || __tgScrolled)) {
      e.preventDefault();
      e.stopPropagation();
    }
    __tgStart = null;
    __tgScrolled = false;
    __tgMax = 0;
  }, true);
})();
